//@ts-ignore
import { post } from '@mindtickle/api-helpers';
import { getFeatureFlagStatus } from './utils';
import {
  SYNC_ENABLED_USER,
  USE_MT_AUTH,
  USE_CALLAI_MF,
  SHARING_WORKFLOW_ENABLE,
} from './constants';

export const fetchUserSyncEnabledInCallAI = async ({
  sessionId,
  cname,
}: {
  sessionId: string;
  cname: string;
}) => {
  let defaultResponse = {
    isUserSyncEnabledInCallAI: false,
    toUseMTAuth: false,
    callAIBaseUrl: '',
    useCallAIMF: false,
    isSharingWorkflowEnabled: false,
  };
  try {
    const { data, errors } = await post(
      {
        url: `${process.env.CALL_AI_API_BASE_URL}/graphapi`,
      },
      {
        headers: {
          'x-token': sessionId,
        },
        body: {
          query: `query CallaiCompanySettings($cname:String!) {
            getTenantByMtCname(cname:$cname) {
                id
                name
            }
            getFeatureFlags {
                name
                isEnabledForTenant
                active
            }
            getCallAIBaseUrl {
              url
            }
        }`,
          variables: {
            cname,
          },
        },
      }
    );
    return !errors || errors.length <= 0
      ? {
          isUserSyncEnabledInCallAI: getFeatureFlagStatus(data, SYNC_ENABLED_USER),
          toUseMTAuth: getFeatureFlagStatus(data, USE_MT_AUTH),
          callAIBaseUrl: data.getCallAIBaseUrl.url,
          useCallAIMF: getFeatureFlagStatus(data, USE_CALLAI_MF),
          isSharingWorkflowEnabled: getFeatureFlagStatus(data, SHARING_WORKFLOW_ENABLE),
        }
      : defaultResponse;
  } catch (errors) {
    console.error(errors); // eslint-disable-line
    return defaultResponse;
  }
};
